<script>
import { mapMutations } from "vuex";
import AccordionSubItemAlgoServer from "./AccordionSubItemAlgoServer.vue";

export default {
  name: "AccordionItemAlgoServer",
  components: {
    AccordionSubItemAlgoServer,
  },
  props: {
    item: Object,
    dataItem: Object,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      checkedItem: [],
    };
  },
  mounted() {
    if (!this.dataItem) {
      this.setSelectedAlgoServer([]);
      this.checkedItem = [];
    }
    this.$nextTick(() => {
      window.addEventListener("resize", this.onResize);
    });
  },
  methods: {
    ...mapMutations(["setSelectedAlgoServer"]),
    onResize() {
      this.windowWidth = window.innerWidth;
    },
    startTransition(el) {
      el.style.height = el.scrollHeight + "px";
    },
    endTransition(el) {
      el.style.height = "";
    },
    toggle(event) {
      this.$parent.$children.forEach((item) => {
        if (
          item.$el.id === event.currentTarget.parentElement.parentElement.id
        ) {
          item.item.active = !item.item.active;
        } else {
          item.item.active = false;
        }
      });
    },
    changeAlgoServerItems(item) {
      const index = this.checkedItem.findIndex(
        (existingItem) => existingItem.id === item.id
      );

      if (
        item.dateSelection !== undefined &&
        (!this.checkedItem[index] ||
          this.checkedItem[index].dateSelection !== item.dateSelection)
      ) {
        if (index !== -1) {
          this.checkedItem[index] = item;
        } else {
          this.checkedItem.push(item);
        }
      } else {
        this.checkedItem = this.checkedItem.filter((e) => e.id !== item.id);
      }
      this.setSelectedAlgoServer(this.checkedItem);
    },
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>
<template>
  <div :id="item.id" class="accordion-item" :class="{ active: item.active }">
    <div class="accordion-item-title">
      <button @click="toggle" class="accordion-item-trigger">
        <h4 class="accordion-item-title-text">{{ item.title }}</h4>
        <h5 class="accordion-item-subtitle">
          Seçilenler:
          <span :key="index" v-for="(item, index) in checkedItem">
            {{ item.name }}
            <span v-if="index != checkedItem.length - 1">,</span>
          </span>
        </h5>
        <span class="accordion-item-trigger-icon"></span>
      </button>
    </div>
    <transition
      name="accordion-item"
      @enter="startTransition"
      @after-enter="endTransition"
      @before-leave="startTransition"
      @after-leave="endTransition"
    >
      <div v-show="item.active" class="accordion-item-details">
        <div class="accordion-item-details-inner">
          <div v-if="windowWidth > 640" class="non-responsive-container">
            <table class="table" aria-describedby="accordion-table">
              <thead>
                <tr>
                  <th scope="col"></th>
                </tr>
              </thead>
              <tbody>
                <accordion-sub-item-algo-server
                  v-for="data in item.details"
                  :key="data.name"
                  :item="data"
                  :dataItem="dataItem"
                  :isResponsive="false"
                  @changeAlgoServerItems="changeAlgoServerItems($event)"
                />
              </tbody>
            </table>
          </div>
          <div v-else class="responsive-container">
            <accordion-sub-item-algo-server
              v-for="data in item.details"
              :key="data.name"
              :item="data"
              :dataItem="dataItem"
              :isResponsive="true"
              @changeAlgoServerItems="changeAlgoServerItems($event)"
            />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<style lang="scss" scoped>
.accordion-item {
  &-subtitle {
    font-size: 13px;
    font-weight: 400;
    margin-top: 5px;
    color: var(--grayscale-50);
    @media (max-width: 768px) {
      font-size: 12px;
    }
  }
  .table {
    border-collapse: collapse;
    text-indent: 0;
    min-width: 100%;
    border-radius: var(--radius-second) !important;
    overflow: auto;
    border: solid 1px var(--color-primary-tint-second);
    background-color: #fff;
    margin: 20px 0px;
    overflow-y: visible !important;
    ::v-deep thead {
      display: none;
    }
    ::v-deep th {
      background: var(--grayscale-160);
      height: 63px;
    }
    ::v-deep th,
    ::v-deep td {
      font-size: 12px;
      vertical-align: middle;
      border-top: 1px solid #e8e8e8;
      .option {
        .veri-dagitim-selectbox.v-select {
          border: 1px solid transparent;
          width: 100%;

          .vs {
            &__dropdown-toggle {
              padding: 0px;
              border: 0px !important;
              position: relative;

              &:focus-visible {
                outline: none !important;
              }
            }

            &__selected {
              padding: 0;
              margin: 0;

              &-options {
                padding: 0px !important;
                position: relative;
              }
            }

            &__clear {
              display: none !important;
            }

            &__actions {
              padding: 0px;
              cursor: pointer !important;
            }
          }

          &__search,
          &__search:focus {
            border: none !important;
          }
        }

        .editing-view-port {
          display: none !important;
        }
      }
    }
    ::v-deep tbody {
      tr:nth-child(2n) {
        background: var(--color-primary-zebra);
      }
      tr td {
        height: 63px;
        label {
          display: block;
          text-align: left;
          margin-bottom: 5px;
          font-size: 12px;
          color: var(--color-primary-black-metallic);
          font-weight: 500;
        }
        &:nth-child(2) {
          min-width: 76px;
        }
      }
      tr td:first-child {
        width: 38px;
        padding: 0px;
        padding-right: 6px;
        text-align: right;
      }

      td:last-child {
        padding-right: 20px;
        width: 170px;
        text-align: center;
        .veri-dagitim-selectbox.v-select {
          .vs__dropdown-toggle {
            min-width: auto;
            font-size: 14px;
          }
          .vs__search {
            display: none;
          }
        }
      }
    }
  }
}
.non-responsive-container {
  display: block;
}
.responsive-container {
  display: none;
}
@media (max-width: 640px) {
  .non-responsive-container {
    display: none;
  }
  .responsive-container {
    display: block;
  }
}
</style>
